/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import "./Hoa.css";
import buildingimage from "../../images/building-bg.png";
import buildingimagesecond from "../../images/building-bg-right.png";
import linedcircle from "../../images/lined-circle.png";
import circleleft from "../../images/circle-left-bg.png";
import circleright from "../../images/circle-right-bg.png";
import FooterComponent from "../../Pages/Footer/Footer";
import HeaderComponent from "../../Pages/Header/Header";
import collage_img from "../../images/collage_hoa.png";
import compliance from "../../images/compliance.svg";
import public_security from "../../images/publickey.svg";
import share_img from "../../images/secure.svg";
import resident_img from "../../images/resident_img.png";
import public_sharing from "../../images/public-sharing.png";
import compliance_img from "../../images/compliance.png";
import man_burdenimg from "../../images/reduceoverhead.png";
import { useNavigate } from "react-router-dom";
function HoaComponent() {
  const navigate = useNavigate()
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top
  }, []);
  return (
    <>
      <HeaderComponent />
      <section className="one hoa-page-section">
        <div className="container">
          {/* <HeaderComponent /> */}
          <div className="banner-content">
            <h1 className="text-center m-0 title-main">
              HOME OWNER ASSOCIATIONS
            </h1>
            <p className="text-center hoa-subtitle">
              HOA Management, Compliance, and Communication
            </p>
            <div className="hz-line"></div>
          </div>
        </div>
        <div className="building-block-left">
          <img src={buildingimage} alt="building-pic"></img>
        </div>
        <div className="building-block-right">
          <img src={buildingimagesecond} alt="building-pic"></img>
        </div>
      </section>
      <section className="two text-center hoa-section-two">
        <div className="container">
          <div className="streamline-content">
            <h2>Compliance, Transparency, and Community Engagement</h2>
            <p className="text-center hoa-subtitle mt-4">
              <strong>Act Now:</strong> Ensure Compliance or Face Costly
              Lawsuits! Stay ahead of Florida's HB 1203 and HB 59 mandates with
              HOA Verified—protect your association from legal risks while
              streamlining operations.
            </p>
            <div className="circle-left">
              <img src={circleleft} alt="circle-img"></img>
            </div>
          </div>
          <div className="row mt-5 hoa-verified-row">
            <div className="col-md-6">
              <h2 className="text-start mb-4">What is HOA Verified?</h2>
              <p className="hoa-verified-info text-start">
                HOA Verified helps homeowner associations and property
                management companies comply with Florida mandates by providing a
                secure, document and communication portal for residents.
                Additionally, the platform offers a public-facing page that
                allows non- residents to explore communities, access detailed
                rules, regulations, and applications, and read authentic
                reviews—all while alleviating phone calls and emails from
                realtors and non-resident members.
              </p>
              <div className="text-start mt-5">
                <button className="btn btn-outline get-started" type="submit" onClick={() => navigate("/signupone")}>
                  Get Started{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="#222222"
                  >
                    <path d="M13.3364 7.84518L6.16426 15.0173L4.98575 13.8388L12.1579 6.66667H5.83643V5H15.0031V14.1667H13.3364V7.84518Z"></path>
                  </svg>
                </button>
              </div>
            </div>
            <div className="col-md-6">
              <div className="collage_img_block position-relative">
                <div className="collage_img position-relative">
                  <img src={collage_img} alt="collage-image"></img>
                </div>
                <div className="circle-right-hoa">
                  <img src={circleright} alt="circle-img"></img>
                </div>
                <div className="circle-left-hoa">
                  <img src={linedcircle} alt="circle-img"></img>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="two text-center hoa-section-two">
        <div className="container">
          <div className="streamline-content-lower-block">
            <h2>Streamline Your HOA's Compliance and Communication</h2>
            <p className="text-center hoa-subtitle mt-4">
              With HOA Verified, you can minimize operational overhead while
              ensuring your community remains compliant with state regulations.
              The platform provides a transparent and efficient way to manage
              public access to non-sensitive information while keeping resident
              communications secure.
            </p>
          </div>
        </div>
      </section>
      <section className="four hoa-section-four">
        <div className="container">
          <div className="document-block">
            <div className="doc-inner-block">
              <div className="box">
                <div className="box-inner text-center">
                  <img src={compliance} alt="compliance_img"></img>
                  <span>Compliance Made Simple</span>
                  <p>
                    Meet Florida's legal requirements (including HB 1203 and HB
                    59) to avoid penalties and lawsuits, ensuring your HOA
                    operates smoothly and legally.
                  </p>
                </div>
              </div>
              <div className="box">
                <div className="box-inner text-center">
                  <img src={public_security} alt="public-key"></img>
                  <span>Public Access to Key Information</span>
                  <p>
                    Share rules, regulations, and applications with the public,
                    eliminating the need for frequent phone calls and emails.
                  </p>
                </div>
              </div>
              <div className="box">
                <div className="box-inner text-center">
                  <img src={share_img} alt="share"></img>
                  <span>Secure Resident Portal</span>
                  <p>
                    Provide your residents with a protected space for accessing
                    important documents, receiving community updates, and
                    staying engaged.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div></div>
      </section>
      <section className="six hoa-six-section">
        <div className="container">
          <div className="free-trial-box text-center">
            <h2>Ensure Compliance or Risk Costly Lawsuits!</h2>
            <p className="lawsuit-para mb-5">
              Stay ahead of Florida's <strong>HB 1203</strong> and{" "}
              <strong>HB 59</strong> mandates with <strong>HOA Verified</strong>
              . Protect your association from legal risks,streamline operations,
              and stay compliant— <strong>Start your free 30-day trial.</strong>
            </p>
            <div className="button-area d-flex justify-content-center">
              <button
                className="btn btn-outline contact-us mt-3 mb-2"
                type="submit"
                onClick={() => navigate("/Contact")}
              >
                Contact us{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="#222222"
                >
                  <g id="arrow-right-up-line">
                    <path
                      id="Vector"
                      d="M13.9137 10.7054L3.77688 11.0594L3.71871 9.39376L13.8555 9.03977L9.23227 4.72853L10.3689 3.50961L17.073 9.76124L10.8213 16.4653L9.60241 15.3287L13.9137 10.7054Z"
                      fill=""
                    ></path>
                  </g>
                </svg>
              </button>
              <button
                className="btn btn-outline get-started-trail mt-3 mb-2"
                type="submit"
                onClick={() => navigate("/signupone")}
              >
                Get Started{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="#ffffff"
                >
                  <path d="M13.3364 7.84518L6.16426 15.0173L4.98575 13.8388L12.1579 6.66667H5.83643V5H15.0031V14.1667H13.3364V7.84518Z"></path>
                </svg>
              </button>
            </div>
          </div>
          <div className="half-circle-hoa">
            <img src={linedcircle} alt="circle-img"></img>
          </div>
        </div>

        {/* <div className="building-bg-area">
                    <img src={buildingleft} alt="building"></img>
                </div> */}
      </section>
      <section className="vertical-tabs-section">
        <div className="container">
          <h2 className="vertical-tab-heading">Benefits</h2>
          <div className="d-flex align-items-start vertical-tabs">
            <div
              className="nav flex-column nav-pills me-3 vertical-left-block"
              id="v-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              <a
                className="nav-link active"
                id="v-pills-home-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-home"
                type=""
                role="tab"
                aria-controls="v-pills-home"
                aria-selected="true"
              >
                Resident Portal
              </a>
              <a
                className="nav-link"
                id="v-pills-profile-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-profile"
                type=""
                role="tab"
                aria-controls="v-pills-profile"
                aria-selected="false"
              >
                Public Sharing
              </a>
              <a
                className="nav-link"
                id="v-pills-messages-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-messages"
                type=""
                role="tab"
                aria-controls="v-pills-messages"
                aria-selected="false"
              >
                Compliance
              </a>
              <a
                className="nav-link"
                id="v-pills-settings-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-settings"
                type=""
                role="tab"
                aria-controls="v-pills-settings"
                aria-selected="false"
              >
                Reduce Overhead
              </a>
            </div>
            <div className="tab-content" id="v-pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="v-pills-home"
                role="tabpanel"
                aria-labelledby="v-pills-home-tab"
                tabIndex="0"
              >
                <div className="benefits-block">
                  <div className="benefits-inner-block">
                    <div className="benefits-inner-wrapper d-flex flex-column">
                      <div className="portal_img">
                        <img src={resident_img} alt="residemt-portal-img"></img>
                      </div>
                      <h3 className="portal-title">Resident Portal</h3>
                      <div className="portal-info">
                        The residential portal offers secure access to
                        documents, communication, and community updates.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="v-pills-profile"
                role="tabpanel"
                aria-labelledby="v-pills-profile-tab"
                tabIndex="0"
              >
                <div className="benefits-block">
                  <div className="benefits-inner-block">
                    <div className="benefits-inner-wrapper d-flex flex-column">
                      <div className="portal_img">
                        <img
                          src={public_sharing}
                          alt="public-sharing-img"
                        ></img>
                      </div>
                      <h3 className="portal-title">Public Sharing</h3>
                      <div className="portal-info">
                        Public access to non-sensitive info like rules,
                        regulations, applications, and community details.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="v-pills-messages"
                role="tabpanel"
                aria-labelledby="v-pills-messages-tab"
                tabIndex="0"
              >
                <div className="benefits-block">
                  <div className="benefits-inner-block">
                    <div className="benefits-inner-wrapper d-flex flex-column">
                      <div className="portal_img">
                        <img src={compliance_img} alt="compliance-img"></img>
                      </div>
                      <h3 className="portal-title">Compliance</h3>
                      <div className="portal-info">
                        Compliance helps your HOA meet legal requirements, avoid
                        penalties, and maintain good governance by meeting
                        regulations and standards.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="v-pills-settings"
                role="tabpanel"
                aria-labelledby="v-pills-settings-tab"
                tabIndex="0"
              >
                <div className="benefits-block">
                  <div className="benefits-inner-block">
                    <div className="benefits-inner-wrapper d-flex flex-column">
                      <div className="portal_img">
                        <img src={man_burdenimg} alt="man-burdened-img"></img>
                      </div>
                      <h3 className="portal-title">Reduce Overhead</h3>
                      <div className="portal-info">
                        The public-facing page minimizes staff emails and phone
                        calls from realtors and non-residents.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FooterComponent />
    </>
  );
}

export default HoaComponent;
